import React, { useContext as useContextCore } from 'react'
import { queries } from '../graphql'
import { useParams } from 'react-router-dom'
import { useDocument } from '@ztechapps/common.hook'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const { _id } = useParams()
  const documentResult = useDocument({ ...queries.singleConfig, _id })

  return <CoreProvider value={{ ...props, ...documentResult }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
